// @flow

import React, { Component, type ComponentType } from 'react';
import type { Dispatch } from 'redux';
import { connect } from 'react-redux';
import type { OpeningHours } from '../../types';
import {
  fetchOpeningHours,
  getOpeningHours,
  startOpeningHoursPolling,
  stopOpeningHoursPolling,
} from '../../store/openinghours';

type InjectProps = {
  openingHours: OpeningHours | void,
};

function withOpeningHours <Props: {}>(
  WrappedComponent: ComponentType<Props>,
): ComponentType<$Diff<Props, InjectProps>> {
  type StateProps = {|
    openingHoursFromState: OpeningHours,
  |};

  type DispatchProps = {|
    fetch: Function,
    start: Function,
    stop: Function,
  |};

  type HoCProps = StateProps & DispatchProps;

  class WithOpeningHours extends Component<Props & HoCProps> {
    componentDidMount() {
      const { fetch, start } = this.props;
      fetch();
      start();
    }

    componentWillUnmount() {
      const { stop } = this.props;
      stop();
    }

    render() {
      const {
        fetch,
        start,
        stop,
        openingHoursFromState,
        ...props
      } = this.props;
      return <WrappedComponent {...props} openingHours={openingHoursFromState} />;
    }
  }

  const mapStateToProps = (state): StateProps => ({
    openingHoursFromState: getOpeningHours(state),
  });

  const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchProps => ({
    fetch: () => dispatch(fetchOpeningHours()),
    start: () => dispatch(startOpeningHoursPolling()),
    stop: () => dispatch(stopOpeningHoursPolling()),
  });

  return connect(mapStateToProps, mapDispatchToProps)(WithOpeningHours);
}

export default withOpeningHours;
